import React, { isValidElement, cloneElement } from 'react';

export const useSlot = (props) => {
  const { name, children } = props;

  const matchedChildren = React.Children.map(children, (child) => {
    if (isValidElement(child)) {
      const isExact = child.props.slot === name;
      return isExact
        ? cloneElement(child, {
            //* remove slot from child props
            slot: undefined,
          })
        : null;
    }
  });

  return {
    matchedChildren,
  };
};
